const formatDate = (date) => new Date(date)
    .toISOString()
    .slice(0, 10)
    .replace(/-/g, '');
const getPdfName = (pdfPrefix, createdAt, userName) => (`${pdfPrefix} - ${userName} - ${formatDate(createdAt)}.pdf`);
export default getPdfName;
